import script from "./BuscadorGruposDesktopHome.vue?vue&type=script&setup=true&lang=js"
export * from "./BuscadorGruposDesktopHome.vue?vue&type=script&setup=true&lang=js"

import "./BuscadorGruposDesktopHome.vue?vue&type=style&index=0&id=3d9df088&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d9df088"]])

export default __exports__